import React, { useEffect } from 'react';
import { Box, Text, VStack, Button } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { SUPPORT_EMAIL, ROUTES } from '../constants';

const SubscriptionExpiredPage: React.FC = () => {
  const { user, loading } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    // If not authenticated, redirect to login
    if (!user) {
      navigate(ROUTES.LOGIN, { replace: true, state: { from: location } });
      return;
    }

    // Note: PaidPeriodGuard already verified subscriptionExpired=true before
    // redirecting here. This page only needs to check authentication.
  }, [user, loading, navigate, location]);

  const handleContactUs = () => {
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Subscription Renewal Request`;
  };

  // Show loading while checking auth
  if (loading) {
    return (
      <Box className="base-container">
        <VStack className="simple-box" top={{ base: "200px", sm: "233px" }} spacing="16px">
          <Text className="title-text-big" textAlign="center" color="#C6D959">
            Loading...
          </Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box className="base-container">
      <VStack className="simple-box" top={{ base: "200px", sm: "233px" }} spacing="16px">
        <Text
          className="title-text-big"
          textAlign="center"
        >
          Your subscription has expired
        </Text>

        <Text className="subtitle-text-center">
          To renew your subscription and continue using the platform, please contact us on {SUPPORT_EMAIL}
        </Text>

        <Button
          className="button-big"
          onClick={handleContactUs}
          marginTop="20px"
          _hover={{
            backgroundColor: "#b8cc4a"
          }}
        >
          Contact us
        </Button>
      </VStack>
    </Box>
  );
};

export default SubscriptionExpiredPage;
